import { gcApi } from 'config/axios';

import { takeEvery, call, put } from 'redux-saga/effects';

import {
    FETCH_LATEST_POWER_TO_WEIGHT,
    FETCH_LATEST_POWER_TO_WEIGHT_FETCHING,
    FETCH_LATEST_POWER_TO_WEIGHT_SUCCESS,
    FETCH_LATEST_POWER_TO_WEIGHT_FAIL
} from '../actions/ActionTypes';

// Workers
export function* fetchLatestPowerToWeight(action) {
    try {
        const {
            payload: { calendarDate, sport }
        } = action;
        let url = `/biometric-service/biometric/powerToWeight/latest/${calendarDate}`;
        url += sport ? `?sport=${sport}` : '';

        yield put({
            type: FETCH_LATEST_POWER_TO_WEIGHT_FETCHING
        });

        const response = yield call(gcApi.get, url);

        yield put({
            type: FETCH_LATEST_POWER_TO_WEIGHT_SUCCESS,
            powerToWeight: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_LATEST_POWER_TO_WEIGHT_FAIL
        });
    }
}

// Watchers
export const ftpSagas = [takeEvery(FETCH_LATEST_POWER_TO_WEIGHT, fetchLatestPowerToWeight)];
